module.exports = __webpack_public_path__ + "img/day01.b229871d.png";